import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgInfo = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      d="M12 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10M12 16.5v-4M12 8.5h.01"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </Svg>
);
const Memo = memo(SvgInfo);
export default Memo;
